import { AuthFlowError } from '@griply/types';
import { useMutation } from '@tanstack/react-query';
import { forgotPassword, signOutUser } from 'shared/services/backend-api';

export const useForgotPasswordMutation = () =>
  useMutation<void, AuthFlowError, { email: string }>({
    mutationFn: async ({ email }) => {
      await signOutUser();
      await forgotPassword(email);
    },
  });
